import styled from 'styled-components';
import { Grid } from 'react-styled-flexboxgrid';

export default styled(Grid)`
  .user-top {
    padding-top: 70px;
  }
  .avatar {
    height: 170px;
    width: 400px;
  }
  .tabs-section {
    padding-top: 60px;
    padding-left: 15px;
    .tabs {
      flex-direction: row;
      justify-content: flex-start;
      padding-top: 10px;
      padding-bottom: 10px;
      & > button {
        margin-right: 50px;
        display: inline-flex;
        margin-bottom: 15px;
      }
    }
  }
  @media only screen and (max-width: 1023px) {
    .tabs-section {
      .tabs {
        & > button {
          margin-right: auto;
        }
      }
    }
  }
  @media only screen and (max-width: 767px) {
    .user-top {
      padding-top: 35px;
    }
    .tabs-section {
      padding-left: 0;
      .tabs {
        display: flex;
        justify-content: space-between;
        padding: 0;
        & > button {
          margin: 0;
          flex-direction: column;
          span {
            margin: 2px auto;
            font-size: 14px;
            svg {
              height: 24px;
              width: 24px;
            }
            &:hover,
            &.active {
              &::after {
                width: 0;
              }
            }
            span {
              margin: 0 !important;
            }
          }
        }
      }
    }
  }
`;

export const TabContent = styled('div')`
  padding-bottom: 80px;
  padding-top: 10px;
  .tab-content {
    animation: fadeEffect 0.3s;
    width: 100%;
  }
  @keyframes fadeEffect {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;
export const AdsWrapper = styled(Grid)`
  padding-left: 15px;
  padding-right: 15px;
  flex-grow: 1;
  position: relative;
  .loading {
    display: block;
  }
  .mobile {
    display: none;
  }
  @media only screen and (max-width: 1023px) {
    .loading {
      display: none;
    }
    .mobile {
      display: block;
    }
  }
  @media only screen and (max-width: 767px) {
    padding-left: 0;
    padding-right: 0;
  }
`;

export const ButtonWrapper = styled('div')`
  .btn {
    &.delete {
      cursor: pointer;
      border: 1px solid rgba(11, 47, 63, 0.4);
      border-radius: 5px;
      color: rgba(11, 47, 63, 0.4);
      font-family: Poppins;
      font-size: 14px;
      font-weight: 500;
      padding: 10px 20px;
      transition: all 0.3s;
      &.disabled {
        opacity: 0.5;
      }
      &:hover {
        border: 1px solid rgba(11, 47, 63, 0.8);
        color: rgba(11, 47, 63, 0.8);
      }
      i {
        margin-right: 2px;
      }
    }
  }
`;
